import { drawing as d } from '@progress/kendo-drawing';
import { defined } from './../utils';
import { VisualBase } from './VisualBase';
import { HEIGHT, WIDTH, X, Y } from '../constants';
import { drawPolygon, drawRoundedPolygon, sizeOptionsOrDefault } from './utils';
/**
 * A visual element that renders a rectangle shape.
 * Extends VisualBase and provides functionality for creating and managing rectangular graphics.
 */
export class Rectangle extends VisualBase {
    /**
     * Creates a new Rectangle instance.
     * @param options Configuration options for the rectangle
     */
    constructor(options) {
        super(options);
        this._initPath();
        this._setPosition();
        this._initAccessibility();
    }
    /** @hidden */
    _setPosition() {
        const options = this.options;
        const x = options.x;
        const y = options.y;
        if (defined(x) || defined(y)) {
            this.position(x || 0, y || 0);
        }
    }
    /**
     * Redraws the rectangle with updated options.
     * @param options New options to apply to the rectangle
     */
    redraw(options) {
        if (options) {
            super.redraw(options);
            if (this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
                this._drawPath();
            }
            if (this._diffNumericOptions(options, [X, Y])) {
                this._setPosition();
            }
        }
    }
    /** @hidden */
    _initPath() {
        const options = this.options;
        this.drawingElement = new d.Path({
            stroke: options.stroke,
            id: options.id
        });
        this._fill();
        this._drawPath();
    }
    /** @hidden */
    _drawPath() {
        const { width, height } = sizeOptionsOrDefault(this.options);
        const drawingElement = this.drawingElement;
        const points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        if (this.options.cornerRadius > 0) {
            drawRoundedPolygon(drawingElement, points, this.options.cornerRadius);
        }
        else {
            drawPolygon(drawingElement, points);
        }
    }
}
